// extracted by mini-css-extract-plugin
export default {"root":"PartiesTable_root__IaK7Q","footer":"PartiesTable_footer__XrDbI"};